module.exports = __webpack_public_path__ + "static/media/inf_03og04.8da2e330.mp3";